import { render, staticRenderFns } from "./AppRightSidebar.vue?vue&type=template&id=2ff6bcf0&"
import script from "./AppRightSidebar.vue?vue&type=script&lang=js&"
export * from "./AppRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppRightSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports